import { render, staticRenderFns } from "./AppMediaGallery.vue?vue&type=template&id=efca221a&"
import script from "./AppMediaGallery.vue?vue&type=script&lang=js&"
export * from "./AppMediaGallery.vue?vue&type=script&lang=js&"
import style0 from "./AppMediaGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports